module.exports = __webpack_public_path__ + "img/solution_subsystem_04@2x.d614f534.png";